import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    gap: 16
  },
  collectionFilesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  documentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row'
    }
  },
  fileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  fileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  fileName: {
    fontSize: 14,
    fontWeight: 600,
    wordBreak: 'break-word'
  },
  fileIcon: {
    position: 'relative'
  },
  blueLines: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  iconWrapper: {
    display: 'flex',
    gap: 2
  },
  iconBtn: {
    margin: 0,
    padding: 8
  },
  actionBtn: {
    zIndex: 100,
    color: GRAY_COLORS[600]
  },
  date: {
    fontSize: 12,
    fontWeight: 400,
    color: GRAY_COLORS[600]
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    wordBreak: 'break-word'
  }
}))
